import { EventEmitter } from 'events';

// Types the events itself rather than extending Node's generic EventEmitter:
// that generic resolves its per-event types only for literal call sites, so a
// method generic over the key needs stacked casts to get past it. subscribe
// returns the unsubscribe closure the Node API lacks.
class TypedEventEmitter<Events> extends EventEmitter {
    emit<K extends keyof Events>(event: string | symbol | K, ...args: Events[K] extends undefined ? [] : [Events[K]]): boolean {
        return super.emit(event as string | symbol, ...args);
    }

    on<K extends keyof Events>(event: string | symbol | K, listener: (args: Events[K]) => void): this {
        return super.on(event as string | symbol, listener);
    }

    once<K extends keyof Events>(event: string | symbol | K, listener: (args: Events[K]) => void): this {
        return super.once(event as string | symbol, listener);
    }

    subscribe<K extends keyof Events>(event: K, listener: (args: Events[K]) => void): () => void {
        this.on(event, listener);
        return () => {
            this.off(event as string | symbol, listener);
        };
    }
}

export { TypedEventEmitter };
